'use strict';

var _set = require('../_internal/_set');

var equals = require('../equals/equals');

module.exports = uniq;
function uniq(arr) {
  return _set(arr, equals).values();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/nanoutils/cjs/uniq/index.js
// module id = 951
// module chunks = 0